<div class="row">
  <div class="col-md-4 mb-4">
    <fieldset style="border: 0;" [disabled]="!hasRole('admin-editor')">
      <div class="card shadow-sm me-0">
        <div class="card-body p-4">
          <div class="row">
            <app-material-auto-complete
              id="docType"
              [(ngModel)]="helloGuide.documentType"
              (ngModelChange)="typesAccept($event)"
              name="docType"
              [placeholder]="'Select Document Type'"
              [items]="documentTypes"
              [formatter]="documentTypeFormatter"
              [required]="true">
            </app-material-auto-complete>
          </div>
          <div class="row mb-3 form-group">
            <app-material-chunk-file-uploader
              [accept]="accept"
              [fileSize]="50000000"
              id="helpUpload"
              name="helpUpload"
              [(ngModel)]="doc"
              (ngModelChange)="getFileId($event)"
              [required]="true">
            </app-material-chunk-file-uploader>
          </div>
          <div class="row">
            <div class="col-sm-12 text-end">
              <button
                mat-raised-button
                mat-stroked-button
                class="pull-right"
                [disabled]="!helloGuide.fileId || !helloGuide.documentType"
                (click)="save()">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="col-md-8 mb-4">
    <div class="card shadow-sm me-0">
      <div class="card-body p-4">
        <h5 class="card-title fs-4 fw-bold">Uploaded Files</h5>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Document Type</th>
              <th>Content Type</th>
              <th>Upload Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          @if (uploadedFiles?.length > 0) {
            <tbody>
              @for (file of uploadedFiles; track $index) {
                <tr>
                  <td>{{ file.fileName }}</td>
                  <td>{{ file.documentType }}</td>
                  <td>{{ file.fileType }}</td>
                  <td>{{ uploadDate(file)| date: 'medium' }}</td>
                  <td>
                    <button class="btn btn-link"
                      (click)="downloadFile(file.fileId)"
                      title="Download file">
                      <i class="fas fa-download"></i>
                    </button>
                    <button class="btn btn-link text-danger"
                      (click)="removeFile(file)"
                      title="Delete file">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          } @else {
            <tr>
              <td colspan="4" class="text-muted text-center">
                No files uploaded yet.
              </td>
            </tr>
          }

        </table>
      </div>
    </div>
  </div>
</div>